import { Component, Input, OnInit } from '@angular/core';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { ProductRequestDetail_Interface } from 'src/app/Interface/ProductRequestDetail_Interface';
import { Empty_ProductRequest_Interface, ProductRequest_Interface } from 'src/app/Interface/ProductRequest_Interface';
import { ProductRequestService } from 'src/app/Service/ProductRequest/ProductRequest.service';

@Component({
  selector: 'app-ProductRequestView',
  templateUrl: './ProductRequestView.component.html',
  styleUrls: ['./ProductRequestView.component.scss']
})
export class ProductRequestViewComponent implements OnInit {

  @Input() inner_ProductRequest_id: number = 0
  Total_Price_Detail:number=0
  
  constructor(
    private ProductRequest_Service: ProductRequestService,

  ) { }

  ngOnInit() {
    this.CheckProductRequest()
  }

  Data_Seleted_Product_Record: ProductRequest_Interface = Empty_ProductRequest_Interface()
  Datalist_Dsc: Array<General_Interface> = []
  DataList_ProductRequestDetail: Array<ProductRequestDetail_Interface> = []


  CheckProductRequest() {

    this.ProductRequest_Service.GetSingleProductRequest(this.inner_ProductRequest_id).subscribe(
      data => {

        this.Data_Seleted_Product_Record = data['record']
        this.DataList_ProductRequestDetail = data['record']['detail']
        for (let item of data['dsc']) {
          var temp:General_Interface=Empty_General_Interface()
          temp.title=item
          this.Datalist_Dsc.push(temp)
        }
        this.Cal_Total_Price_Detail()
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Cal_Total_Price_Detail() {
    this.Total_Price_Detail = 0
    for (let item of this.DataList_ProductRequestDetail) {
      this.Total_Price_Detail = this.Total_Price_Detail + (item.price * item.amount)
    }
  }


}
